import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { decodeUriParam, encodeUriParam } from 'utils';
import { useDispatch, useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { history } from 'app.history';
import { useParams } from 'react-router-dom';
import { searchAction } from '../../../../common/actions/search';
import { searchSelector } from '../../../../common/selectors/search';

export const SearchForm = ({ className }) => {
  const { t } = useTranslation();
  const { searchTerm } = useParams();
  const prevSearchTermRef = useRef();
  const dispatch = useDispatch();
  const search = useSelector(searchSelector);

  const [searchValue, setSearchValue] = useState('');

  if (prevSearchTermRef.current !== searchTerm) {
    setSearchValue(decodeUriParam(searchTerm, !search.searchedByForm));
    prevSearchTermRef.current = searchTerm;
  }

  const onSearchSubmitHandler = (e) => {
    dispatch(searchAction(true));

    if (searchValue) {
      history.push(`/search/${encodeUriParam(searchValue)}/?sort=relevance`);
    }

    e.preventDefault();
    return false;
  };

  return (
    <div className={className ? className : ''}>
      <form role="search" className="ct-search-form" onSubmit={onSearchSubmitHandler}>
        <div className="ct-search-form__input-group">
          <input
            type="search"
            name="search"
            aria-label={t('search')}
            placeholder={t('search.placeholder')}
            className="ct-search-form__input-elem"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            autoFocus
            data-e2e="search-videos-input"
          />

          <button
            type="submit"
            className="ct-search-form__magnifier"
            onClick={onSearchSubmitHandler}
            data-e2e="search-videos-confirm-button"
            aria-label={t('search.send_button.label')}
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
      </form>
    </div>
  );
};
